export default theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
    // [theme.breakpoints.down('xs')]: {
    //   bottom: '79px',
    // },
    zIndex: 6,
  },
  formControl: {
    width: '100%',
  },
  appBar: {
    position: 'fixed',
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  colorOnContactSelection: {
    backgroundColor: '#fff',
  },
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  menu: {
    width: 200,
  },
  formHelperText: {
    textAlign: 'right',
  },
  dateTimePickerLabel: {
    display: 'block',
    fontSize: '11.5px',
    lineHeight: '11px',
    backgroundColor: '#fff',
    marginTop: '-3px',
    marginLeft: '40px',
    textAlign: 'left',
    position: 'absolute',
    zIndex: 1,
    padding: '0 5px',
  },
  root: {
    flexGrow: 1,
  },
  dialogContent: {
    [theme.breakpoints.up(600)]: {
      paddingTop: '64px',
    },
    [theme.breakpoints.down(600)]: {
      paddingTop: '48px',
    },
    overflowY: 'scroll',
    height: '100%',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    // [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
    //   width: 600,
    //   marginLeft: 'auto',
    //   marginRight: 'auto',
    // },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    // padding: theme.spacing.unit * 2,
    // [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
    //   marginTop: theme.spacing.unit * 6,
    //   marginBottom: theme.spacing.unit * 6,
    //   padding: theme.spacing.unit * 3,
    // },
  },
  // cards: {
  //   marginTop: '10px',
  //   height: 330,
  //   overflowX: 'scroll',
  //   overflowY: 'hidden',
  //   whiteSpace: 'nowrap',
  // },
  card: {
    // maxWidth: 345,
    // height: 300,
    textAlign: 'left',
    // marginRight: 45,
    whiteSpace: 'normal',
  },
  media: {
    // height: 0,
    // paddingTop: '56.25%', // 16:9
  },
  gridListTile: {
    cursor: 'pointer',
  },
  // gridList: {
  //   flexWrap: 'nowrap',
  //   // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
  //   transform: 'translateZ(0)',
  // },
  gridListTitle: {
    color: '#fff',
  },
  titleBar: {
    background: 'transparent',
    textAlign: 'center',
  },
  tile: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
    borderRadius: '12px',
    '&:hover': {
      boxShadow: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
    },
  },
  hover: {},
  heading: {
    color: '#fff',
    fontSize: '90%',
    fontWeight: 'bold',
    marginRight: 7,
  },
  expandIcon: { color: '#fff' },
  expansionPanelSummary: {
    backgroundColor: theme.palette.secondary.main,
    padding: '0 60px 0 24px',
  },
  expansionPanelSummaryExpanded: {
    borderTopLeftRadius: 35,
    borderTopRightRadius: 35,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  expansionPanelExpanded: {
    borderRadius: '35px !important',
  },
  phone: {
    border: 'solid #dddddd 15px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    maxWidth: '500px',
    margin: 'auto',
  },
  phoneContainer: {
    margin: '25px 16px 16px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
  },
  defaultValuesButton: {
    position: 'absolute',
    bottom: 5,
    right: 5,
    // [theme.breakpoints.down('sm')]: {
    //   bottom: 5,
    //   right: 5,
    // },
  },
  formPanel: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
  },
  tabs: {
    boxShadow: '0 0',
  },
  expansionPanelDetails: {
    flexGrow: 1,
    padding: 0,
    display: 'block',
  },
  chat: {
    margin: 0,
    position: 'relative',
    maxWidth: 'initial',
    padding: '20px 20px 55px',
    height: 'calc(100vh - 495px)',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 342px)',
    },
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 219px)',
    },
  },
  chatWithAttachment: {
    margin: 0,
    position: 'relative',
    maxWidth: 'initial',
    padding: '20px 20px 175px',
    height: 'calc(100vh - 495px)',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 342px)',
    },
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 219px)',
    },
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  textField: {
    margin: '12px',
  },
  directions: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  navSectionBottom: {
    position: 'fixed',
    bottom: '64px',
    boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
    background: '#fff',
    width: '100%',
    margin: 0,
    zIndex: 2,
    [theme.breakpoints.down('xs')]: {
      bottom: '56px',
    },
    transition: '0.2s',
  },
  navSectionBottomSMS: {
    position: 'fixed',
    bottom: 0,
    boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
    background: '#fff',
    width: '100%',
    margin: 0,
    zIndex: 2,
    transition: '0.2s',
  },
  navSectionBottomSMSClosed: {
    position: 'fixed',
    bottom: '-240px',
    boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
    background: '#fff',
    width: '100%',
    margin: 0,
    zIndex: 2,
    [theme.breakpoints.down('xs')]: {
      bottom: '-240px',
    },
    transition: '0.2s',
  },
  navSectionBottomClosed: {
    position: 'fixed',
    bottom: '-330px',
    boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
    background: '#fff',
    width: '100%',
    margin: 0,
    zIndex: 2,
    [theme.breakpoints.down('xs')]: {
      bottom: '-338px',
    },
    transition: '0.2s',
  },
  navSectionBottomClosedSnippets: {
    position: 'fixed',
    bottom: '-113px',
    boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
    background: '#fff',
    width: '100%',
    margin: 0,
    zIndex: 2,
    [theme.breakpoints.down('xs')]: {
      bottom: '-113px',
    },
    transition: '0.2s',
  },
  navSectionBottomClosedVariables: {
    position: 'fixed',
    bottom: '-230px',
    boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
    background: '#fff',
    width: '100%',
    margin: 0,
    zIndex: 2,
    [theme.breakpoints.down('xs')]: {
      bottom: '-230px',
    },
    transition: '0.2s',
  },
  navSection: {
    width: '100%',
    margin: 0,
    zIndex: 2,
    transition: '0.2s',
  },
  codeButton: {
    marginRight: theme.spacing.unit,
  },
  expansionPanel: {
    position: 'fixed',
    width: '100%',
    boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
    left: 80,
    paddingRight: 80,
    [theme.breakpoints.down('xs')]: {
      left: 0,
      paddingRight: 0,
    },
  },
  expansionPanelMobile: {
    position: 'absolute',
    width: '100%',
    boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
    // left: 55,
    // paddingRight: 55,
    [theme.breakpoints.down('xs')]: {
      left: 0,
      paddingRight: 0,
    },
  },
  panelDetailsRootMobile: {
    padding: '19px 10px 24px',
  },
  panelDetailsRootMobileContacts: {
    padding: '19px 10px 24px',
    display: 'block',
  },
  column: {
    flexBasis: '50%',
  },
  panelDetails: {
    padding: '7px',
  },
  panelSummary: {
    justifyContent: 'space-between',
    flexGrow: 0,
    padding: 0,
  },
  panelSummaryExpanded: {
    margin: '0 !important',
    minHeight: '0 !important',
  },
  panelSummaryContent: {
    margin: 0,
  },
  expansionPanelNoMargin: {
    [theme.breakpoints.down('sm')]: {
      left: 0,
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      left: 81,
      width: 'calc(100% - 81px)',
    },
  },
  panelExpanded: {
    margin: 0,
  },
  grid: {
    // maxWidth: '800px',
    // margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 3,
      width: '100%',
    },
  },
  icon: { fontSize: '1rem' },
  color: { color: '#fff' },
  warning: { color: theme.palette.orange },
  error: { color: theme.palette.red },
  headingIcon: {
    fontSize: '1rem',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  initialForm: {
    border: '1px solid #adadad',
    padding: 20,
    borderRadius: 35,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      borderRadius: 0,
      height: '100%',
      overflowY: 'auto',
    },
  },
  initialFormModal: {
    padding: 20,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      borderRadius: 0,
      height: '100%',
      overflowY: 'auto',
      // margin: 8,
    },
  },
  actionTypeHeadingContainer: {
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  actionTypeHeading: {
    color: '#fff',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    display: 'table-cell',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  notchedOutline: {
    borderRadius: 28,
    paddingLeft: '40px !important',
  },
  bottomNavExpanded: {
    margin: 0,
  },
  buttonsStyle: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      left: 0,
      top: 56,
    },
    width: 'calc(100% - 80px)',
    position: 'fixed',
    left: '80px',
    // bottom: '0px',
    top: 64,
    padding: '12px',
    background: 'white',
    boxShadow: '0px 5px 5px #00000040',
    zIndex: 1,
  },
  buttonsStyleModal: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      left: 0,
      right: 0,
      // bottom: 0,
      top: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    width: 'calc(100% - 96px)',
    position: 'fixed',
    left: '48px',
    // bottom: '48px',
    top: 48,
    right: '48px',
    padding: '12px',
    background: 'white',
    boxShadow: '0px 5px 5px #00000040',
    borderTopLeftRadius: 28,
    borderTopRightRadius: 28,
    zIndex: 1,
  },
  main: {
    height: '100%',
    paddingTop: 60,
    [theme.breakpoints.down('sm')]: {
      // marginTop: 54,
      paddingTop: 54,
    },
  },
  mainModal: {
    // marginTop: 61,
    height: '100%',
  },
  splitGrid: {
    [theme.breakpoints.down('xs')]: {
      width: '100vw',
    },
  },
  left: {
    // height: '100%',
    // minWidth: 707,
    // maxWidth: 707,
    // width: 707,
    // [theme.breakpoints.down('md')]: {
    // 	// width: 'auto',
    // 	// minWidth: 0,
    // },
  },
  right: {
    height: '100%',
    // minWidth: 'calc(100vw - 845px)',
    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: 'auto',
    },
  },
  mainContainer: {
    paddingTop: 72,
    [theme.breakpoints.down('sm')]: {
      // padding: maybe something else for 'sm' size,
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 55,
    },
  },
  emailHeaderText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  emailHeaderTextError: {
    color: theme.palette.orange || 'orange',
    padding: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      padding: 5,
    },
  },
  emailScroll: {
    // height: '97%',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  splitFormGrid: {
    margin: 0,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
})
